import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import RegisterWizard from "@/components/RegisterWizard";
import Faq from "@/components/Faq";
import { LaunchBenefit } from "@/components/LaunchBenefit";
import { useLanguage } from "@/context/LanguageContext";

export default function People() {
  const { t } = useLanguage();

  return (
    <div className="bg-[#faf8f5] text-slate-900 antialiased min-h-screen">
      <Seo page="people" />
      <Header />

      {/* Intro */}
      <section className="hero-grid-pat py-20 border-b spec-border" data-testid="people-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 max-w-4xl">
          <span className="text-xs font-mono-spec text-gold-700 font-semibold tracking-[0.18em] uppercase">{t.peoplePage.eyebrow}</span>
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-slate-950 mt-3 leading-[1.1]">
            {t.peoplePage.title}
          </h1>
          <p className="text-lg text-slate-600 mt-4 max-w-2xl leading-relaxed">{t.peoplePage.sub}</p>
          <Link
            to="/#register"
            data-testid="people-hero-cta"
            className="inline-flex items-center justify-center mt-8 px-6 py-3.5 bg-slate-950 text-white text-sm font-semibold rounded-sm hover:bg-gold-800 transition-colors shadow-md"
          >
            {t.peoplePage.cta}
          </Link>
        </div>
      </section>

      {/* Control */}
      <section className="py-20 bg-white border-b spec-border" data-testid="people-control">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <h2 className="text-3xl font-bold tracking-tight text-slate-950 mb-12">{t.peoplePage.controlTitle}</h2>
          <div className="grid sm:grid-cols-2 gap-6">
            {t.peoplePage.control.map((c, i) => (
              <div key={c.t} className="p-6 bg-slate-50 border spec-border rounded-sm">
                <span className="font-mono-spec text-xs text-gold-700 font-bold">0{i + 1}</span>
                <h3 className="text-base font-bold text-slate-950 mt-2">{c.t}</h3>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed">{c.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Earnings */}
      <section className="py-16 bg-slate-100/60 border-b spec-border" data-testid="people-earnings">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl font-bold tracking-tight text-slate-950 mb-4">{t.peoplePage.earningsTitle}</h2>
          <p className="text-base text-slate-600 leading-relaxed">{t.peoplePage.earnings}</p>
          <p className="mt-4 p-4 bg-white border spec-border text-sm font-mono-spec text-slate-700 rounded-sm" data-testid="people-honesty">
            {t.peoplePage.honesty}
          </p>
        </div>
      </section>

      {/* Launch benefit */}
      <section className="py-20 bg-white border-b spec-border" data-testid="people-launch-benefit">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <LaunchBenefit />
        </div>
      </section>

      {/* Registration */}
      <section id="register" className="py-20 bg-slate-100/60 border-b spec-border" data-testid="people-register">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <span className="text-xs font-mono-spec text-gold-700 font-semibold tracking-wider uppercase">{t.register.eyebrow}</span>
            <h2 className="text-3xl font-bold tracking-tight text-slate-950 mt-2">{t.register.title}</h2>
            <p className="text-slate-600 mt-2 text-sm">{t.register.sub}</p>
          </div>
          <RegisterWizard />
        </div>
      </section>

      <Faq />
      <Footer />
    </div>
  );
}
